import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '../translate/translate.module';
import { ListaPagamentiComponent } from './components/lista-pagamenti/lista-pagamenti.component';
import { VisualizzaDettagliComponent } from './components/visualizza-dettagli/visualizza-dettagli.component';
import { DatiPagamentoComponent } from './components/dati-pagamento/dati-pagamento.component';
import { FormattaImportoPipe } from './pipe/formatta-importo.pipe';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { TabellaCronologicaStatiComponent } from './components/tabella-cronologica-stati/tabella-cronologica-stati.component';
import { Paths } from './service/Paths';

@NgModule({
  declarations:
    [ListaPagamentiComponent,
      DatiPagamentoComponent,
      VisualizzaDettagliComponent,
      FormattaImportoPipe,
      TabellaCronologicaStatiComponent
    ],
  imports: [
    CommonModule,
    HttpClientModule,
    MatTableModule,
    TranslateModule,
    MatExpansionModule,
    MatButtonModule,
    MatInputModule
  ],
  exports: [ListaPagamentiComponent],
  providers: [Paths],
})
export class PagamentiModule { }
